import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface, } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_06_Interface, Empty_DataEntity_Detail_06_Interface } from 'src/app/Interface/DataEntity/06/DataEntity_Detail_06_Interface';
import { DataEntity_Main_06_Interface, Empty_DataEntity_Main_06_Interface } from 'src/app/Interface/DataEntity/06/DataEntity_Main_06_Interface';
import { DataEntity_Resolution_06_Interface, Empty_DataEntity_Resolution_06_Interface } from 'src/app/Interface/DataEntity/06/DataEntity_Resolution_06_Interface';
import { Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity06Service } from 'src/app/Service/DataEntity/06/DataEntity06.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-DataEntity06',
  templateUrl: './DataEntity06.component.html',
  styleUrls: ['./DataEntity06.component.scss']
})
export class DataEntity06Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity06_Service: DataEntity06Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }

  Token: String = '';
  FileName: string = '';
  FolderName: string = '';
  Capability: string = '';

  CertificateCode: String = '';
  CertificateUrlPdf: string = ''

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';


  DataEntity_Id: number = 9;


  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;
  Calibration_Id: number = 0;
  Observation: number = 0;


  unit_reference: string = ''
  unit_working: string = ''
  unit_correction_eqution: string = ''

  unit_indication: string = ''
  unit_deviation: string = ''
  unit_uncertainty: string = ''

  working_min: string = ''
  working_max: string = ''
  accuracy: string = ''


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),
    });

    this.ResolutionFormDataEntity = new FormGroup({
      range_max: new FormControl(null, [Validators.required]),
      range_min: new FormControl(null, [Validators.required]),
      scale: new FormControl(null, [Validators.required]),
    });


    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.OnIntial();
  }

  OnIntial() {
    this.DataEntity06_Service.GetSingle(this.Token, this.Calibration_Device_Id, this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {
          var temp: DataEntity_Main_06_Interface = Empty_DataEntity_Main_06_Interface();
          this.Observation = data['observation'];
          this.DataList_Resolution = data['resolution'];



          this.Nominal_Value_List = []

          temp = data['result'];
          this.Calibration_Id = temp.id;
          this.FileName = temp.filename;
          this.FolderName = temp.pdf_src;
          this.Capability = temp.capability;

          this.unit_working = temp.unit_working;
          this.unit_reference = temp.unit_reference;
          this.unit_indication = temp.unit_indication;
          this.unit_deviation = temp.unit_deviation;
          this.unit_uncertainty = temp.unit_uncertainty;
          this.unit_correction_eqution = temp.unit_correction_eqution;


          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;

          this.working_max = temp.working_max;
          this.working_min = temp.working_min;
          this.accuracy = temp.accuracy;


          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""



          this.get_Form_Temperature_Air_before().setValue(temp['temperature_Air_before']);
          this.get_Form_Temperature_Air_after().setValue(temp['temperature_Air_after']);

          this.get_Form_Humidity_Air_before().setValue(temp['humidity_Air_before']);
          this.get_Form_Humidity_Air_after().setValue(temp['humidity_Air_after']);

          this.get_Form_Pressure_before().setValue(temp['pressure_before']);
          this.get_Form_Pressure_after().setValue(temp['pressure_after']);

          for (let item of data['detail']) {

            var tempDetail: DataEntity_Detail_06_Interface = Empty_DataEntity_Detail_06_Interface();

            tempDetail.converage = item['converage'];
            tempDetail.sample = item['sample'];
            tempDetail.reference_up = item['reference_up'];
            tempDetail.reference_down = item['reference_down'];
            tempDetail.uncertainty = item['uncertainty'];


            tempDetail.before = item['before'];


            this.Nominal_Value_List.push(tempDetail);



          }
        }

        //this.MainDataEntity_List = data['result']
        //this.UploadImageSrc_List = data['image']
        //this.canAdd_SubmitDATEOFISSUE_Date = data['canAdd_SubmitDATEOFISSUE_Date']
        //this.SubmitDATEOFISSUE_Date = data['certificate_Code']['date_of_issue']
        this.Read_Unit()
        this.CertificateCode = data['certificate_Code'];
      },
      (error) => {
        localStorage.clear()
        location.reload();
      }
    );
  }

  //#region Main Data Entity

  Nominal_Value_List: Array<DataEntity_Detail_06_Interface> = [];
  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }


  //#endregion

  //#region Upload

  Procssing_Import: boolean = false
  upload_file_excel(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import = true

    this.DataEntity06_Service.uploadFile(formData, this.Type_txt, this.Token).subscribe(
      data => {
        this.Procssing_Import = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Nominal_Value_List = []
          this.Alerify_Service.SuccessMessage("The information was loaded successfully.")

          this.FileName = data['filename']
          this.Capability = data['capability']

          for (let item of data['nominal']) {
            var temp: DataEntity_Detail_06_Interface = Empty_DataEntity_Detail_06_Interface()

            temp.converage = item['converage'];
            temp.sample = item['sample'];
            temp.reference_up = item['reference_up'];
            temp.reference_down = item['reference_down'];
            temp.uncertainty = item['uncertainty'];
            this.Nominal_Value_List.push(temp)
          }

        }
      }
    )

  }

  Procssing_Import2: boolean = false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2 = true

    this.DataEntity06_Service.uploadPdf(formData, this.Token).subscribe(
      data => {
        this.Procssing_Import2 = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Alerify_Service.SuccessMessage("The information was loaded successfully.")
          this.FolderName = data['fodlername']

        }
      }
    )

  }

  //#endregion

  //#region Unit
  modalRef_Unit:any
  DataList_Unit: Array<Unit_Interface> = []
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.Token, this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit = data
      },
      (error) => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  Selected_Unit:string=''

  OnUserSetUnit(index:Number,template: TemplateRef<any>){
    if(!this.unit_reference && index!=1)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_indication && index!=2)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_deviation && index!=3)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_correction_eqution && index!=4)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_uncertainty && index!=5)
      this.Set_Selected_Unit(index,template)
    else if(!this.unit_working && index!=6)
      this.Set_Selected_Unit(index,template)
  }

  Set_Selected_Unit(index:Number,template: TemplateRef<any>){
    if(index==1)
      this.Selected_Unit=this.unit_reference
    else if(index==2)
      this.Selected_Unit=this.unit_indication
    else if(index==3)
      this.Selected_Unit=this.unit_deviation
    else if(index==4)
      this.Selected_Unit=this.unit_correction_eqution
    else if(index==5)
      this.Selected_Unit=this.unit_uncertainty
    else if(index==6)
      this.Selected_Unit=this.unit_working

    if(this.Selected_Unit)
      this.modalRef_Unit = this.modalService.show(template);
  }

  SetToAllUnit(){
    if(!this.unit_reference)
      this.unit_reference=this.Selected_Unit

    if(!this.unit_indication)
      this.unit_indication=this.Selected_Unit

    if(!this.unit_deviation)
      this.unit_deviation=this.Selected_Unit

    if(!this.unit_correction_eqution)
      this.unit_correction_eqution=this.Selected_Unit

    if(!this.unit_uncertainty)
      this.unit_uncertainty=this.Selected_Unit

    if(!this.unit_working)
      this.unit_working=this.Selected_Unit

    this.modalRef_Unit.hide()
  }

  //#endregion

  //#region Calibration
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Set_CalibrationDeviceInfo_click(input: Calibration_Interface) {
    this.Calibration_Device = input
  }

  //#endregion

  //#region Resolution
  ResolutionFormDataEntity: FormGroup;
  DataList_Resolution: Array<DataEntity_Resolution_06_Interface> = []

  Delete_Resolution(id: number) {
    this.DataList_Resolution.splice(id, 1)
    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  Add_Resolution() {

    var CanAdd: Boolean = true
    for (let item of this.DataList_Resolution) {
      if (Number(item.range_min) <= Number(this.get_Form_range_min().value) && Number(this.get_Form_range_min().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
      else if (Number(item.range_min) <= Number(this.get_Form_range_max().value) && Number(this.get_Form_range_max().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
    }

    if (this.DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("A maximum of 7 range and resolution entries can be registered.")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_06_Interface = Empty_DataEntity_Resolution_06_Interface()
      temp.range_min = this.get_Form_range_min().value + ''
      temp.range_max = this.get_Form_range_max().value + ''
      temp.scale = this.get_Form_scale().value + ''
      this.DataList_Resolution.push(temp)
      this.Alerify_Service.SuccessMessage("The information was saved successfully.")
    }
    else {
      this.Alerify_Service.ErrorMessage("The new data overlaps existing data.")
    }
  }


  get_Form_range_min() {
    return this.ResolutionFormDataEntity.get('range_min') as FormControl;
  }

  get_Form_range_max() {
    return this.ResolutionFormDataEntity.get('range_max') as FormControl;
  }

  get_Form_scale() {
    return this.ResolutionFormDataEntity.get('scale') as FormControl;
  }

  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input: string) {
    this.Calibration_Device.labAdderss = input

  }

  //#endregion

  //#region Before

  Add_Before(index: number) {
    var Temp_Total_Nominal_Value_List: Array<DataEntity_Detail_06_Interface> = [];
    Temp_Total_Nominal_Value_List = this.Nominal_Value_List

    if ((Temp_Total_Nominal_Value_List.length) > index + 1 && Temp_Total_Nominal_Value_List[index + 1].before == true) {
      this.Alerify_Service.ErrorMessage("Copied as the before value.")
    }
    else {

      var Temp_Nominal_Value_List: Array<DataEntity_Detail_06_Interface> = [];

      for (let item of Temp_Total_Nominal_Value_List) {

        if (Temp_Total_Nominal_Value_List.indexOf(item) != index) {
          Temp_Nominal_Value_List.push(item);
        }
        else {
          Temp_Nominal_Value_List.push(item);

          var tempDetail: DataEntity_Detail_06_Interface = Empty_DataEntity_Detail_06_Interface();

          tempDetail.sample = item.sample;
          tempDetail.reference_down = item.reference_down;
          tempDetail.reference_up = item.reference_up;

          tempDetail.uncertainty = item.uncertainty;
          tempDetail.converage = item.converage;
          tempDetail.uncertainty = item.uncertainty;
          tempDetail.before = true;


          Temp_Nominal_Value_List.push(tempDetail);
        }
      }
      this.Nominal_Value_List = Temp_Nominal_Value_List



    }
  }


  Delete_Before(index: number) {
    this.Nominal_Value_List.splice(index, 1)

    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion


  modalRef_CodeSerial: any;
  modalRef_CodeSerial_Title: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {

    if ((!this.Calibration_Device.device_serial || !this.Calibration_Device.device_code || this.Calibration_Device.device_serial.trim() == "" || this.Calibration_Device.device_code.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "The instrument serial number or code has not been registered. "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((this.Model_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "The model has not been registered. "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }

    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_06_Interface = Empty_DataEntity_Main_06_Interface();

      temp.id = this.Calibration_Id;

      temp.unit_working = this.unit_working;
      temp.unit_reference = this.unit_reference;
      temp.unit_indication = this.unit_indication;
      temp.unit_deviation = this.unit_deviation;
      temp.unit_uncertainty = this.unit_uncertainty;
      temp.unit_correction_eqution = this.unit_correction_eqution;

      temp.working_max = this.working_max
      temp.working_min = this.working_min
      temp.accuracy = this.accuracy

      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value;
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value;

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value;
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value;

      temp.pressure_before = this.get_Form_Pressure_before().value;
      temp.pressure_after = this.get_Form_Pressure_after().value;

      this.DataEntity06_Service.Submit(
        temp,
        this.Nominal_Value_List,
        this.DataList_Resolution,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FileName,
        this.FolderName,
        this.Capability,
        this.Calibration_Device.device_serial,
        this.Calibration_Device.device_code,
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.Calibration_Device.labAdderss,
        this.Token
      ).subscribe((data) => {
        this.InProccessing = false;
        if (data['id'] == -1) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else if (data['certificate_Code'] == '') {
          this.Alerify_Service.ErrorMessage('System error.');
        } else {
          this.CertificateCode = data['certificate_Code'];
          this.Alerify_Service.SuccessMessage('The information was saved successfully.');

          this.OnIntial()

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          this.modalRef_Code = this.modalService.show(template);
        }
      });

    }
  }

  onSubmit_Code(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {
    this.onSubmit(template, templateCodeSerial, 1)
    this.modalRef_CodeSerial.hide()
  }


}
